// extracted by mini-css-extract-plugin
module.exports = {"listVideoItem":"VideoItem_listVideoItem_gUCoZ","brandList":"VideoItem_brandList_3p40J"};